import React from 'react';
import ReactDOM from 'react-dom/client';
import './lang/i18n.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.scss';
import './styles/styles-theme.scss';
import { initVersionCheck } from './services/versionCheck';

// Khởi chạy kiểm tra phiên bản từ manifest.json & tự động xóa cache khi có bản build mới
initVersionCheck();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // eslint-disable-next-line react-hooks/exhaustive-deps

  <HelmetProvider>
    {/* Navigations run as transitions: while the next page's chunk loads, the current page stays on screen. */}
    <BrowserRouter future={{ v7_startTransition: true }}>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
reportWebVitals();
